export default "__VITE_ASSET__C_y4s989__"